$(document).ready(function() {
  // fetch(window.Shopify.routes.root + 'products/phantom-asian-fit.js')
  // .then(response => response.json())
  // .then(product => //console.log(product));
  var sliderSelectors = ['#slider-range','#slider-range-mobile'];
  sliderSelectors.forEach(selector => priceSliderInit(selector));

  const handle = $("#list-product-grid").data("handle");
  var filters = [];
  getFilters();

  // filter.p.m.custom.eyewear
  // filter.p.tag
  $("details input[type=checkbox]").on('changed', function() {
    getFilters();
  })

})
function getFilters() {
  var checkedList = $("details input:checked");
  filters = checkedList.map((index, input) => {
    var filterName = $(input).attr('name');
    var filterValue = $(input).val();
    //console.log(filterName,filterValue)
    if (filterName && filterName.startsWith('filter.p.m.')) {
      filterName = filterName.replace('filter.p.m.', '').split('.')
      var filter = {
        productMetafield: {
          namespace: filterName[0],
          key: filterName[1],
          value: filterValue
        }
      }
      //console.log(JSON.stringify(filter),'huhu')
    }
  })
}
function priceSliderInit(selector) {
  if ($('.facets__header-vertical').length == 0 || !$('.facets__header-vertical').data("currency")) return;
  var input_event = new Event('input',{ bubbles: true});
  // var min_val = 0;
  var min_val = parseFloat($('.facets__header-vertical').data("min"));
  var max_val = parseFloat($('.facets__header-vertical').data("max"));
  var currency = $('.facets__header-vertical').data("currency").trim();
  var current_min = 0;
  if ($('price-range input.min').val()) {
    current_min = $('price-range input.min').val();
  }
  var current_max = $('.facets__header-vertical').data("max");
  if ($('price-range input.max').val()) {
    current_max = $('price-range input.max').val();
  }
  //console.log('why slider',current_max)

  if ($( selector ).length) {
    $( selector ).slider({
      range: true,
      min: min_val,
      max: max_val,
      values: [ current_min, current_max ],
      slide: function( event, ui ) {
        $('.range-value input.min').val( currency + ' ' + ui.values[ 0 ])
        $('.range-value input.max').val( currency + ' ' + ui.values[ 1 ])
        //console.log('hi')
  
      
        var target_min = document.querySelector('price-range input.min');
        $('price-range input.min').val(ui.values[ 0 ]).trigger('change').trigger('input')
        // target_min.dispatchEvent(changed_event);
        target_min.dispatchEvent(input_event);
  
        var target_max = document.querySelector('price-range input.max');
        $('price-range input.max').val(ui.values[ 1 ]).trigger('change').trigger('input')
        // target_min.dispatchEvent(changed_event);
        target_max.dispatchEvent(input_event);
        $('.price-range-remove').html(currency + ' ' + ui.values[ 0 ] + ' - ' + currency + ' ' + ui.values[ 1 ])
      }
    });
    $('.range-value input.min').val( currency + ' ' + $( selector ).slider( "values", 0 ))
    $('.range-value input.max').val( currency + ' ' + $( selector ).slider( "values", 1 ))
  }
}